module.exports = __webpack_public_path__ + "static/media/img-time-of-day.73e017fb.png";